module.exports = "/assets/0605aa2515784f496f64b6bd4ccc2bb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/IR.png
// module id = 1484
// module chunks = 0